import React, { ReactNode } from 'react';
import { AuthProvider } from 'shared/contexts/AuthContext';
import { AppUpdateProvider } from 'shared/contexts/AppUpdateContext';
import { SupportPanelProvider } from 'shared/contexts/SupportPanelContext';
import { ErrorBoundary } from 'shared/components/ErrorBoundary';
import { SessionRepair } from './SessionRepair';

export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <SessionRepair />
        <AppUpdateProvider>
          <SupportPanelProvider>{children}</SupportPanelProvider>
        </AppUpdateProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
